import { pathExists } from "fs-extra";
import { ensureArray } from "@buurman/commons";
import { shell } from "../shell";

export interface GitApi {
    isGitRepository(): Promise<boolean>;
    hasCleanWorkingCopy(): Promise<boolean>;

    command(command: string, args?: string[]): this;

    init(): this;
    add(files: string | string[]): this;
    commit(message: string, flags?: string[]): this;
    push(flags?: string[]): this;

    execute(): Promise<void>;
}

const git = () => {
    const commands: string[][] = [];

    const api: GitApi = {
        isGitRepository: () => pathExists(`.git`),
        hasCleanWorkingCopy: async () =>
            !(await shell().exec("git", [`status`, `--porcelain`])),

        command: (command, args = []) => {
            commands.push([command, ...args]);
            return api;
        },

        init: () => api.command("init"),
        add: files => api.command("add", ensureArray(files)),
        commit: (message, flags = []) =>
            api.command("commit", [...flags, "-m", message]),
        push: (flags = []) => api.command("push", flags),

        execute: async () => {
            for (const args of commands) {
                await shell().exec("git", args);
            }
        },
    };

    return api;
};

export default git;
